import React from 'react';
import { Link } from 'react-router-dom';
import { Bot, Calendar, MessageSquare, Clock, TrendingUp, Shield, Check } from 'lucide-react';

const Home = () => {
  const features = [
    {
      icon: <Calendar size={32} />,
      title: 'Gestione Appuntamenti',
      description: 'Automatizza la prenotazione e gestione degli appuntamenti 24/7 con reminder automatici.'
    },
    {
      icon: <MessageSquare size={32} />,
      title: 'Assistente Conversazionale',
      description: 'Rispondi automaticamente alle domande più comuni dei clienti in tempo reale.'
    },
    {
      icon: <Clock size={32} />,
      title: 'Disponibilità H24',
      description: 'Il tuo agente AI è sempre attivo, anche fuori orario lavorativo.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Aumento delle Conversioni',
      description: 'Converti più lead in clienti grazie a risposte immediate e personalizzate.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Sicurezza e Privacy',
      description: 'Tutti i dati sono protetti e conformi alle normative GDPR.'
    },
    {
      icon: <Bot size={32} />,
      title: 'Personalizzazione Completa',
      description: 'Agenti AI configurati specificamente per il tuo business e settore.'
    }
  ];

  const useCases = [
    {
      title: 'Centri Estetici',
      description: 'Gestione prenotazioni trattamenti, consulenze online, promemoria per appuntamenti.',
      benefits: ['Riduzione no-show del 40%', 'Aumento prenotazioni del 35%', 'Risparmio 10h/settimana']
    },
    {
      title: 'Ristoranti',
      description: 'Prenotazioni tavoli, menu del giorno, ordini take-away, informazioni su allergeni.',
      benefits: ['Più prenotazioni online', 'Meno telefonate', 'Gestione automatica menu']
    },
    {
      title: 'Studi Medici',
      description: 'Prenotazione visite, gestione liste d\'attesa, promemoria esami, informazioni pratiche.',
      benefits: ['Ottimizzazione agenda', 'Riduzione assenze', 'Migliore esperienza paziente']
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Agenti AI per il Tuo Business</h1>
          <p>
            Automatizza la gestione clienti con assistenti AI intelligenti. 
            Perfetti per centri estetici, ristoranti e studi medici.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary" style={{ fontSize: '1.1rem', padding: '1rem 2rem' }}>
              Inizia Gratis
            </Link>
            <Link to="/pricing" className="btn btn-outline" style={{ 
              fontSize: '1.1rem', 
              padding: '1rem 2rem',
              color: 'white',
              borderColor: 'white'
            }}>
              Vedi Prezzi
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Funzionalità Principali</h2>
          <p className="section-subtitle">
            Tutto ciò di cui hai bisogno per automatizzare la gestione dei tuoi clienti
          </p>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="features" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Perfetto Per Il Tuo Settore</h2>
          <p className="section-subtitle">
            Soluzioni personalizzate per ogni tipo di business
          </p>

          <div className="features-grid">
            {useCases.map((useCase, index) => (
              <div key={index} className="feature-card">
                <h3 style={{ color: 'var(--primary)' }}>{useCase.title}</h3>
                <p style={{ marginBottom: '1.5rem' }}>{useCase.description}</p>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {useCase.benefits.map((benefit, idx) => (
                    <li key={idx} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '0.5rem',
                      marginBottom: '0.5rem',
                      color: 'var(--success)'
                    }}>
                      <Check size={20} />
                      <span style={{ color: 'var(--gray)' }}>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ 
        background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
        padding: '5rem 0',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
            Pronto a Rivoluzionare il Tuo Business?
          </h2>
          <p style={{ fontSize: '1.25rem', marginBottom: '2rem', opacity: 0.95 }}>
            Inizia subito con una prova gratuita di 14 giorni. Nessuna carta di credito richiesta.
          </p>
          <Link to="/register" className="btn" style={{
            background: 'white',
            color: 'var(--primary)',
            fontSize: '1.1rem',
            padding: '1rem 2.5rem'
          }}>
            Inizia Ora Gratis
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
